var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSuntrust = function SvgSuntrust(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "suntrust_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 40 26",
    style: {
      enableBackground: "new 0 0 40 26"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".suntrust_svg__st1{fill:#002856}")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M0 0h40v26H0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "suntrust_svg__Calque_5"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.395 15.665c0 .39-.065 1.04-.975 1.04-.195 0-.585 0-.845-.195-.195-.195-.195-.455-.195-.845V14.3c0-.13-.065-.195-.26-.195v-.195h1.235v.195c-.195 0-.26.065-.26.195v1.43c0 .325 0 .715.52.715.585 0 .585-.455.585-.78v-1.43c0-.13 0-.195-.195-.195h-.065v-.195h.845v.195h-.13c-.195 0-.195.065-.195.195v1.43h-.065zM29.62 16.64h-1.365v-.195h.13c.195 0 .26-.065.26-.195v-2.08h-.26c-.13 0-.195.065-.195.13-.065.065-.065.26-.065.39h-.26v-.715h2.21v.715h-.195c0-.13 0-.325-.065-.39s-.13-.13-.195-.13h-.26v2.08c0 .13.065.195.26.195h.13l-.13.195zM27.8 15.925c-.065.455-.39.845-1.04.845-.39 0-.78-.13-.975-.195v-.65h.195v.195s.065.13.13.195c.13.13.26.195.585.195.455 0 .585-.195.585-.455s-.195-.325-.715-.52c-.585-.13-.845-.325-.845-.845 0-.455.325-.845.975-.845.39 0 .585.065.845.195v.585h-.195v-.195c0-.065-.065-.195-.13-.195-.195-.195-.39-.195-.585-.195s-.52.13-.52.39c0 .195.13.325.585.455.455.13.585.195.78.26.325.26.39.455.325.78M12.525 15.665c-.065.52-.455.975-1.43.975-.52 0-1.04-.195-1.235-.325v-.845h.26v.26c0 .065.065.195.13.26.195.195.39.325.845.325.585 0 .845-.325.845-.65 0-.39-.26-.52-.975-.65-.65-.195-1.105-.39-1.105-1.04 0-.585.455-1.105 1.365-1.105.585 0 .845.13 1.04.195v.78h-.195v-.26c0-.13-.13-.195-.195-.26-.195-.065-.455-.13-.715-.065-.325 0-.65.195-.65.52s.13.455.78.585c.585.13.845.195 1.04.39.195.325.195.585.195.91M15.385 14.17c.195 0 .195.065.195.195v2.015c0 .13 0 .195-.195.195h-.065v.13h.845v-.195H16.1c-.195 0-.195-.065-.195-.195v-1.69l1.105 2.015h.585v-2.275c0-.13 0-.195.195-.195h.195v-.325c0-.26 0-.585.39-.585h.39v2.86c0 .195-.065.325-.325.325h-.13v.195H20v-.195h-.13c-.26 0-.325-.065-.325-.325v-2.86h.39c.39 0 .39.26.39.585v.26h.26c.195 0 .195.065.195.195v1.95c0 .13-.13.195-.26.195v.195h1.235v-.195c-.195 0-.26-.065-.26-.195v-2.145h.325c.26 0 .455.13.455.52 0 .195-.13.52-.455.52h-.195s.52.975.585 1.17c.13.195.26.26.585.26h.52v-.195c-.065 0-.195 0-.26-.13l-.585-.975c.325-.065.585-.325.585-.65 0-.65-.65-.65-1.04-.65H20.78V13h-2.925v.975h-.65v.195h.065c.195 0 .195.065.195.195v1.69L16.36 14.04h-1.755v.195h.065c.195 0 .195.065.195.195v1.43c0 .325-.065.78-.585.78s-.52-.39-.52-.715v-1.43c0-.13.065-.195.26-.195v-.195h-1.365v.195c.195 0 .26.065.26.195v1.365c0 .39.065.585.195.78.195.195.65.195.845.195.975 0 .975-.585.975-1.17v-1.43c0 .065 0 0 .195 0l.26-.065z",
    className: "suntrust_svg__st1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_1_",
    x1: 12.259,
    x2: 17.393,
    y1: 250.126,
    y2: 244.007,
    gradientTransform: "translate(0 -239)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m12.46 9.49-.065.195a.718.718 0 0 0 0 .52l.26 1.495c0 .13.065.195.13.195s.065-.13 0-.325l-.195-2.015c-.065-.13-.13-.13-.13-.065",
    style: {
      fill: "url(#suntrust_svg__SVGID_1_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_00000080902868070175225970000004459941316790523067_",
    x1: 12.41,
    x2: 17.526,
    y1: 250.269,
    y2: 244.172,
    gradientTransform: "translate(0 -239)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#suntrust_svg__SVGID_00000080902868070175225970000004459941316790523067_)"
    },
    d: "M13.045 11.115v.26c-.065 0-.065-.065-.13-.195l-.065-.845c0-.13 0-.39.065-.52s.13-.065.13.065v1.235z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_00000079458538293598111390000006300113530864543396_",
    x1: 12.008,
    x2: 17.105,
    y1: 249.944,
    y2: 243.869,
    gradientTransform: "translate(0 -239)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#suntrust_svg__SVGID_00000079458538293598111390000006300113530864543396_)"
    },
    d: "m13.435 8.06-.13 2.6c0 .13 0 .26-.065.26 0 0-.065-.065-.065-.195l-.065-2.21c0-.13.065-.26.13-.39l.065-.195c.065.065.13.065.13.13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_00000091729540152444553820000001394527695499743930_",
    x1: 12.39,
    x2: 17.475,
    y1: 250.276,
    y2: 244.216,
    gradientTransform: "translate(0 -239)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#suntrust_svg__SVGID_00000091729540152444553820000001394527695499743930_)"
    },
    d: "m13.825 8.645-.195 2.015c0 .195-.065.26-.065.26-.065 0-.065-.13-.065-.195l.065-1.755c.065-.13.195-.325.26-.325 0-.195 0-.13 0 0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_00000169550190170641967560000004530116399769269945_",
    x1: 12.17,
    x2: 17.243,
    y1: 250.1,
    y2: 244.054,
    gradientTransform: "translate(0 -239)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#suntrust_svg__SVGID_00000169550190170641967560000004530116399769269945_)"
    },
    d: "M13.89 10.465c-.065 0-.065-.195 0-.195l.26-2.795c0-.13.13-.26.195-.325v-.065c.065-.13.13-.13.13 0l-.455 3.12c-.065.13-.065.26-.13.26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_00000177457166499624262460000013348536138218849980_",
    x1: 12.52,
    x2: 17.58,
    y1: 250.401,
    y2: 244.37,
    gradientTransform: "translate(0 -239)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#suntrust_svg__SVGID_00000177457166499624262460000013348536138218849980_)"
    },
    d: "M14.735 7.54c.065-.065.195-.065.195.065l-.65 2.795c0 .13-.065.26-.13.195-.065 0-.065-.195 0-.26l.455-2.535s.065-.195.13-.26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_00000181085716520442037170000010269138254469462423_",
    x1: 12.856,
    x2: 17.881,
    y1: 250.686,
    y2: 244.697,
    gradientTransform: "translate(0 -239)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#suntrust_svg__SVGID_00000181085716520442037170000010269138254469462423_)"
    },
    d: "M14.8 10.4c-.065.13-.13.195-.195.195s.065-.195.065-.195l1.495-3.705c.065-.13.195-.195.26-.195s0 .26-.065.325c-.845 2.08-1.105 2.665-1.56 3.575"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_00000142149268212331838050000006706054691791592634_",
    x1: 13.069,
    x2: 18.078,
    y1: 250.866,
    y2: 244.898,
    gradientTransform: "translate(0 -239)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#suntrust_svg__SVGID_00000142149268212331838050000006706054691791592634_)"
    },
    d: "M15.125 10.205c.065 0 .13-.065.195-.195l2.795-4.615a.198.198 0 0 0 0-.26c-.065-.065-.195.065-.26.195l-2.6 4.68c-.065.065-.13.195-.13.195"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_00000062159245516766814790000015071502326214515618_",
    x1: 13.566,
    x2: 18.559,
    y1: 251.286,
    y2: 245.336,
    gradientTransform: "translate(0 -239)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#suntrust_svg__SVGID_00000062159245516766814790000015071502326214515618_)"
    },
    d: "M15.255 10.725c-.065-.065 0-.195.13-.26l2.99-4.29c0-.195.195-.325.325-.26s.13.195 0 .26l-3.25 4.29c-.065.195-.195.26-.195.26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_00000049934727794767545950000010627745251957654971_",
    x1: 14.246,
    x2: 19.224,
    y1: 251.857,
    y2: 245.926,
    gradientTransform: "translate(0 -239)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#suntrust_svg__SVGID_00000049934727794767545950000010627745251957654971_)"
    },
    d: "m16.1 10.205-.195.195c-.065-.065.065-.13.13-.195l.13-.13 4.16-4.745c.065-.065.195-.13.195 0l.13.195a.198.198 0 0 1 0 .26l-4.55 4.42z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_00000083804630006492884350000015240082654055940225_",
    x1: 14.69,
    x2: 19.651,
    y1: 252.232,
    y2: 246.32,
    gradientTransform: "translate(0 -239)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#suntrust_svg__SVGID_00000083804630006492884350000015240082654055940225_)"
    },
    d: "M15.775 10.985c-.065-.065.065-.13.195-.195l4.42-4.095a.198.198 0 0 1 .26 0c.13.13.13.195.13.195 0 .13-.065.195-.13.26l-4.615 3.64c-.13.195-.26.26-.26.195"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_00000018201819289098847360000016129442479642763691_",
    x1: 15.398,
    x2: 20.342,
    y1: 252.828,
    y2: 246.936,
    gradientTransform: "translate(0 -239)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#suntrust_svg__SVGID_00000018201819289098847360000016129442479642763691_)"
    },
    d: "m16.685 10.66 5.135-3.705c.13-.065.195-.065.195.065l.13.39c0 .13-.065.195-.195.325l-5.2 3.055c-.13.065-.26.195-.26.13-.065-.13.065-.195.195-.26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_00000088092150629993513940000016910065014129719468_",
    x1: 15.677,
    x2: 20.596,
    y1: 253.057,
    y2: 247.195,
    gradientTransform: "translate(0 -239)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#suntrust_svg__SVGID_00000088092150629993513940000016910065014129719468_)"
    },
    d: "M16.165 11.375c0-.065.13-.13.26-.195l4.615-2.275c.13-.065.195-.065.195.065v.52c0 .13-.13.195-.26.26l-4.55 1.56c-.13.13-.26.13-.26.065"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_00000134219077865133245930000013572463511463287742_",
    x1: 16.357,
    x2: 21.244,
    y1: 253.625,
    y2: 247.801,
    gradientTransform: "translate(0 -239)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#suntrust_svg__SVGID_00000134219077865133245930000013572463511463287742_)"
    },
    d: "m21.495 10.985-4.42.585c-.195 0-.26.065-.325 0 0-.065.13-.13.26-.195l4.615-1.43c.195-.065.26 0 .195.13l-.065.52c.065.195-.065.325-.26.39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_00000120523130471563767730000010538303677018893239_",
    x1: 16.426,
    x2: 21.273,
    y1: 253.676,
    y2: 247.9,
    gradientTransform: "translate(0 -239)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#suntrust_svg__SVGID_00000120523130471563767730000010538303677018893239_)"
    },
    d: "M16.49 12.025c0-.065.195-.13.39-.13l3.9-.455c.195 0 .325.065.26.195l-.065.195c-.065.13-.195.195-.39.195h-3.77c-.195.065-.325.065-.325 0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_00000036223424546072075740000014612215553100947115_",
    x1: 12.488,
    x2: 17.531,
    y1: 250.376,
    y2: 244.366,
    gradientTransform: "translate(0 -239)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#suntrust_svg__SVGID_00000036223424546072075740000014612215553100947115_)"
    },
    d: "M15.905 6.24s-1.105 3.445-1.17 3.705c-.065.195-.13.39-.195.39s0-.13.065-.26l1.04-3.835c.065-.195.195-.26.26-.26.13-.13.065.13 0 .26"
  })));
};
export default SvgSuntrust;